import styled from "styled-components";
import { Color } from "config/colors";
import { CustomIcon } from "components/icon/customIcon.component";

type DrawerProps = {
  open: boolean;
};

export const DrawerStyled = styled.div<DrawerProps>`
  background-color: ${Color.White};
  border-right: 1px solid ${Color.SeaBlue200};
  bottom: 0;
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  left: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;

  @media (min-width: 1000px) {
    display: none;
  }
`;

export const CloseIcon = styled(CustomIcon)`
  align-self: flex-end;
  margin: 20px 20px 0 0;
`;

export const LinkLabel = styled.p`
  margin: 0;
  text-align: center;
`;
